import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/modern-theme.css';
import {
  BrowserRouter,
  Route,
  Routes
} from "react-router-dom";

import Payment from './components/payment';
import CreateInvoice from './components/createInvoice';
import PaymentSuccessful from './components/paymentsuccessful';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/system';
import Estimate from './components/estimate';

function App() {
  const theme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#005fa9', // Match the modern-cta-button color
      },
      secondary: {
        main: '#004a85', // Match the hover color
      },
      success: {
        main: '#2e7d32',
      }
    },
    typography: {
      fontFamily: '"Avenir Next", "Arial", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="min-h-screen flex flex-col">
        <BrowserRouter>
          <div className="container mx-auto py-3 flex-grow">
            <Routes>
              <Route path="/invoice/:invoiceId" element={<Payment />} />
              <Route path="/payment/:invoiceId" element={<Payment />} />
              <Route path="/estimate/:estimateId" element={<Estimate />} />
              <Route path="/createInvoice" element={<CreateInvoice />} />
              <Route path="/createInvoice/:clientId" element={<CreateInvoice />} />
              <Route path="/success/:invoiceId/:email" element={<PaymentSuccessful />} />
              <Route path="/success/:invoiceId" element={<PaymentSuccessful />} />
            </Routes>
          </div>
          <div className="text-center p-4 bg-light border-top mt-auto">
            <p className="mb-0">&copy; {new Date().getFullYear()} The Defined CRM, LLC. All Rights Reserved.</p>
          </div>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
